import { Button } from '@fullscreendigital/carrefour-dex-fe'
import { Grid } from '@mui/material'
import { Modal } from 'components/core-ui/Modal'
import { useNotification } from 'hooks'
import { makeCorePatchRequest } from 'utils/api'
import { formatErrorMessage } from 'utils/formatting'
import s from 'components/core-ui/Modal/Modal.modules.scss'
import { getLocationUnit } from 'components/location/api'

interface DisableConfirmationModalProps {
  isModalOpen: boolean
  closeModal: Function
  id: number
  setShouldRefreshData: Function
  shouldRefreshData: boolean
}

const DisableConfirmationModal = (props: DisableConfirmationModalProps) => {
  const { isModalOpen, closeModal, id, setShouldRefreshData, shouldRefreshData } = props

  const { showNotification } = useNotification()

  const { data: item } = getLocationUnit(showNotification, id, shouldRefreshData)

  const disableLocation = async () => {
    try {
      await makeCorePatchRequest(`/location-management/location-unit/${id}/${!item?.active}`)
      closeModal()
      setShouldRefreshData(true)
    } catch (error) {
      showNotification({
        message: `Error while disableing location. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  return (
    <Modal
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      modalTitle={item?.active ? 'Disable child' : 'Enable child'}
    >
      <Grid container spacing={4}>
        <Grid xs={12} item>
          Are you sure you want to {item?.active ? 'disable' : 'enable'} this child?
        </Grid>

        <Grid xs={12} item className={s.modalButtons}>
          <Button variant="outlined" label="No" onClick={() => closeModal()} />
          <Button variant="contained" label="Yes" onClick={disableLocation} />
        </Grid>
      </Grid>
    </Modal>
  )
}

export default DisableConfirmationModal
